{
  "actionbar.actions": "Ενέργειες",
  "actionbar.actionsAvailable": "Υπάρχουν διαθέσιμες ενέργειες.",
  "actionbar.clearSelection": "Εκκαθάριση επιλογής",
  "actionbar.selected": "{count, plural, =0 {Δεν επιλέχθηκε κανένα} one {# επιλεγμένο} other {# επιλεγμένα}}",
  "actionbar.selectedAll": "Επιλέχθηκαν όλα",
  "breadcrumbs.more": "Περισσότερα στοιχεία",
  "button.pending": "σε εκκρεμότητα",
  "calendar.invalidSelection": "{selectedCount, plural, one {Η επιλεγμένη ημερομηνία δεν είναι διαθέσιμη} other {Οι επιλεγμένες ημερομηνίες δεν είναι διαθέσιμες}}.",
  "combobox.noResults": "Κανένα αποτέλεσμα",
  "contextualhelp.help": "Βοήθεια",
  "contextualhelp.info": "Πληροφορίες",
  "datepicker.endTime": "Χρόνος λήξης",
  "datepicker.startTime": "Ώρα έναρξης",
  "datepicker.time": "Χρόνος",
  "dialog.alert": "Ειδοποίηση",
  "dialog.dismiss": "Απόρριψη",
  "dropzone.replaceMessage": "Απόθεση αρχείου για αντικατάσταση",
  "inlinealert.informative": "Πληροφορίες",
  "inlinealert.negative": "Σφάλμα",
  "inlinealert.notice": "Προειδοποίηση",
  "inlinealert.positive": "Επιτυχία",
  "label.(optional)": "(προαιρετικό)",
  "label.(required)": "(απαιτείται)",
  "menu.moreActions": "Περισσότερες ενέργειες",
  "notificationbadge.indicatorOnly": "Νέα δραστηριότητα",
  "notificationbadge.plus": "{notifications}+",
  "picker.placeholder": "Επιλογή…",
  "picker.selectedCount": "{count, plural, =0 {Δεν επιλέχθηκαν στοιχεία} one {Επιλέχθηκε # στοιχείο} other {Επιλέχθηκαν # στοιχεία}}",
  "slider.maximum": "Μέγιστο",
  "slider.minimum": "Ελάχιστο",
  "table.loading": "Φόρτωση...",
  "table.loadingMore": "Φόρτωση περισσότερων...",
  "table.resizeColumn": "Αλλαγή μεγέθους στήλης",
  "table.sortAscending": "Ταξινόμηση κατά αύξουσα σειρά",
  "table.sortDescending": "Ταξινόμηση κατά φθίνουσα σειρά",
  "tag.actions": "Ενέργειες",
  "tag.hideButtonLabel": "Εμφάνιση λιγότερων",
  "tag.noTags": "Κανένα",
  "tag.showAllButtonLabel": "Εμφάνιση όλων ({tagCount, number})",
  "toast.clearAll": "Εκκαθάριση όλων",
  "toast.collapse": "Σύμπτυξη",
  "toast.showAll": "Εμφάνιση όλων"
}
